import { Text } from "@chakra-ui/react";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { PasskeyButton } from "./PasskeyButton";

interface Props {
  onConfirmed: () => void;
  children?: ReactNode;
}

export const ConfirmPasskeyStep = ({ onConfirmed, children }: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <Text fontSize="3xl">
        <b>{t("Confirm with your passkey")}</b>
      </Text>
      <Text fontSize="md" mt="10px" mb="6">
        {t("Your account is protected by a passkey. Use it to finish logging in.")}
      </Text>
      <PasskeyButton purpose="Confirm" label={t("Use passkey")} w="full" colorScheme="teal" onSuccess={onConfirmed} />
      {children}
    </>
  );
};
